<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/ADC4/ADC4.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">ADC3.0 Driving Domain Controller</div>
                <div class="detail-banner-desc">Liquid cooled.</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            Dual Power Redundancy: the dual power supply for domain control The domain controller requires independent isolation and diagnostic main power supply. In the event of any main power interruption, system power must be maintained.
                        </div>
                        <div>
                            Secure Boot: SOC secure boot: The SOC-side image file is verified during system startup; it can only be mounted and executed after successful verification.
                        </div>
                        <div>
                            Storage Requirements: Support user partition customization and disk partition adjustment, support system partition allocation.
                        </div>
                        <div>
                            Power Management: Supports operating mode, standby mode, low-power mode (MCU on, SOC off), light sleep mode (MCU on, SOC sleep), one-key low power, sentry mode.
                        </div>
                        <div>
                            Housing Material: AL6061
                        </div>
                        <div>
                            Cooling Method: Liquid cooled, withstands coolant temperature up to 65°C.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ADC4/ADC4-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">9V～16V</div>
                                    <div class="k">Operating Voltage</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤220W</div>
                                    <div class="k">Rated Power（room temperature 23°C）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤384W</div>
                                    <div class="k">Peak Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤15A</div>
                                    <div class="k">Rated Current（12V）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤0.5mA</div>
                                    <div class="k">Quiescent Current</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">-40℃~85℃</div>
                                    <div class="k">Operating Temperature</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">-40℃~95℃</div>
                                    <div class="k">Storage Temperature</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">IP52</div>
                                    <div class="k">Protection Rating</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">＜2Kg</div>
                                    <div class="k">Weight</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">256.5 X 230 X 44</div>
                                    <div class="k">Full-size(mm)</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">209 X 220 X 38</div>
                                    <div class="k">Physical size(mm)</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">image display/function entry: 250ms</div>
                                    <div class="k">Hot start time</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">image display: 250ms, function entry: 6s startup time</div>
                                    <div class="k">Cold start time</div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ADC4/ADC4-1.jpg" alt="200-1-02">
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ADC4/ADC4-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">1.0 cm+1 ppm（RMS）</div>
                                    <div class="k">RTK Accuracy: Horizontal</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1.5 cm+1 ppm（RMS）</div>
                                    <div class="k">RTK Accuracy: Elevation</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Scale error 2‰, three-axis orthogonal coupling error 0.9‰ (0.05°)</div>
                                    <div class="k">IMU Performance</div>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'ADC3.0 Driving Domain Controller - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/electronics/ADC3-2.html'
};

import { createApp } from 'vue';
import App from './ADC3-2.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./ADC3-2.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
